var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Einträge")]), _vm._v(" "), (_vm.selectedItem && _vm.selectedItem.id > 0) ? _c('h2', [_vm._v("Bearbeiten")]) : (_vm.selectedItem && _vm.selectedItem.id == 0) ? _c('h2', [_vm._v("Neu")]) : _vm._e(), _vm._v(" "), (!_vm.selectedItem && !_vm.imgEditItem) ? _c('button', {
    on: {
      "click": _vm.addItem
    }
  }, [_vm._v("Neu")]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('LoadingSpinner') : [(!_vm.selectedItem && !_vm.imgEditItem) ? [(_vm.items && _vm.items.length > 0) ? _c('table', {
    staticStyle: {
      "max-width": "100%"
    }
  }, [_c('tr', [_c('th', [_vm._v("Titel")]), _vm._v(" "), _c('th', [_vm._v("Datum")]), _vm._v(" "), _c('th', [_vm._v("Keine Details?")]), _vm._v(" "), _c('th', [_vm._v("Kategorien")]), _vm._v(" "), _c('th', [_vm._v("Aktionen")])]), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('tr', [_c('td', [_vm._v("\n            " + _vm._s(item.title) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(_vm._f("toDateString")(item.date)) + "\n          ")]), _vm._v(" "), _c('td', [(item.noDetails) ? [_vm._v("\n              Ja\n            ")] : [_vm._v("\n              Nein\n            ")]], 2), _vm._v(" "), _c('td', [_vm._l((item.categories), function(category, index) {
      return [_vm._v("\n              " + _vm._s(category.name)), (index + 1 < item.categories.length) ? [_vm._v(", ")] : _vm._e()]
    })], 2), _vm._v(" "), _c('td', [_c('button', {
      on: {
        "click": function($event) {
          _vm.deleteItem(item)
        }
      }
    }, [_vm._v("Löschen")]), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          _vm.selectedItem = item
        }
      }
    }, [_vm._v("Bearbeiten")]), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          _vm.imgEditItem = item
        }
      }
    }, [_vm._v("Bilder")])])])
  })], 2) : [_vm._v("\n        Keine Daten gefunden\n      ")]] : (!_vm.imgEditItem) ? [_c('div', {
    staticClass: "edit-form"
  }, [_c('label', [_vm._v("Titel")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedItem.title),
      expression: "selectedItem.title"
    }],
    attrs: {
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.selectedItem.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectedItem.title = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("Datum")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedItem.date),
      expression: "selectedItem.date"
    }],
    attrs: {
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.selectedItem.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectedItem.date = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("\n          Text"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "https://de.wikipedia.org/wiki/Markdown",
      "target": "_blank"
    }
  }, [_vm._v("(Markdown-Syntax)")])])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedItem.text),
      expression: "selectedItem.text"
    }],
    domProps: {
      "value": (_vm.selectedItem.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectedItem.text = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    attrs: {
      "for": "noDetails"
    }
  }, [_vm._v("\n          Keine Details?\n        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedItem.noDetails),
      expression: "selectedItem.noDetails"
    }],
    attrs: {
      "id": "noDetails",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectedItem.noDetails) ? _vm._i(_vm.selectedItem.noDetails, null) > -1 : (_vm.selectedItem.noDetails)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.selectedItem.noDetails,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectedItem.noDetails = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.selectedItem.noDetails = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectedItem.noDetails = $$c
        }
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("\n          Kategorien\n        ")]), _vm._v(" "), (_vm.categories) ? _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, _vm._l((_vm.categories), function(cat) {
    return _c('div', {
      class: {
        category: true, 'category-selected': cat.selected
      },
      style: (("border-color: " + (cat.color))),
      on: {
        "click": function($event) {
          cat.selected = !cat.selected
        }
      }
    }, [_vm._v("\n            " + _vm._s(cat.name) + "\n          ")])
  })) : _vm._e()]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.saveItem
    }
  }, [_vm._v("Speichern")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.selectedItem = null
      }
    }
  }, [_vm._v("Abbrechen")])] : [_c('h2', [_vm._v("Bilder: " + _vm._s(_vm.imgEditItem.title))]), _vm._v("\n\n      Hinzufügen:\n      "), _c('input', {
    ref: "uploadFiles",
    attrs: {
      "type": "file",
      "name": "uploadFiles",
      "id": "uploadFiles",
      "accept": "image/*",
      "multiple": ""
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.startImageUpload
    }
  }, [_vm._v("Hochladen")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.imgEditItem = null
      }
    }
  }, [_vm._v("Zurück zu den Einträgen")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.saveImageSorting
    }
  }, [_vm._v("Bild-Zuordnung und -Sortierung speichern")]), _vm._v(" "), _c('div', {
    staticClass: "images"
  }, [_c('div', {
    staticClass: "image-container"
  }, [_vm._v("\n          Groß\n          "), _c('div', {
    staticClass: "image-list"
  }, [_c('draggable', {
    staticClass: "dragArea",
    attrs: {
      "options": {
        group: 'images'
      }
    },
    on: {
      "start": function($event) {
        _vm.drag = true
      },
      "end": function($event) {
        _vm.drag = false
      }
    },
    model: {
      value: (_vm.largeImages),
      callback: function($$v) {
        _vm.largeImages = $$v
      },
      expression: "largeImages"
    }
  }, _vm._l((_vm.largeImages), function(img) {
    return _c('div', {
      staticClass: "image"
    }, [_c('img', {
      staticStyle: {
        "max-width": "120px",
        "max-height": "120px"
      },
      attrs: {
        "src": img.url
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.removeImage(img)
        }
      }
    }, [_vm._v("Löschen")])])])
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "image-container"
  }, [_vm._v("\n          Mittel\n          "), _c('div', {
    staticClass: "image-list"
  }, [_c('draggable', {
    staticClass: "dragArea",
    attrs: {
      "options": {
        group: 'images'
      }
    },
    on: {
      "start": function($event) {
        _vm.drag = true
      },
      "end": function($event) {
        _vm.drag = false
      }
    },
    model: {
      value: (_vm.mediumImages),
      callback: function($$v) {
        _vm.mediumImages = $$v
      },
      expression: "mediumImages"
    }
  }, _vm._l((_vm.mediumImages), function(img) {
    return _c('div', {
      staticClass: "image"
    }, [_c('img', {
      staticStyle: {
        "max-width": "120px",
        "max-height": "120px"
      },
      attrs: {
        "src": img.url
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.removeImage(img)
        }
      }
    }, [_vm._v("Löschen")])])])
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "image-container"
  }, [_vm._v("\n          Klein\n          "), _c('div', {
    staticClass: "image-list"
  }, [_c('draggable', {
    staticClass: "dragArea",
    attrs: {
      "options": {
        group: 'images'
      }
    },
    on: {
      "start": function($event) {
        _vm.drag = true
      },
      "end": function($event) {
        _vm.drag = false
      }
    },
    model: {
      value: (_vm.smallImages),
      callback: function($$v) {
        _vm.smallImages = $$v
      },
      expression: "smallImages"
    }
  }, _vm._l((_vm.smallImages), function(img) {
    return _c('div', {
      staticClass: "image"
    }, [_c('img', {
      staticStyle: {
        "max-width": "120px",
        "max-height": "120px"
      },
      attrs: {
        "src": img.url
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.removeImage(img)
        }
      }
    }, [_vm._v("Löschen")])])])
  }))], 1)])])]]], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4369f76e","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/admin/AdminEntries.vue
// module id = 236
// module chunks = 1